var _defs, _path, _path2, _circle, _path3, _circle2, _rect, _circle3, _rect2, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3right",
    "data-name": "3right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 279,
    height: 575,
    viewBox: "0 0 279 575",
    preserveAspectRatio: "xMaxYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .home-bg-right-cls-1 {\n        fill: #d4c527;\n      }\n\n      .home-bg-right-cls-1, .home-bg-right-cls-2, .home-bg-right-cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .home-bg-right-cls-1, .home-bg-right-cls-2 {\n        opacity: 0.5;\n      }\n\n      .home-bg-right-cls-2, .home-bg-right-cls-3 {\n        fill: #ee162d;\n      }\n\n      .home-bg-right-cls-4, .home-bg-right-cls-5, .home-bg-right-cls-6 {\n        fill: #424143;\n      }\n\n      .home-bg-right-cls-4 {\n        opacity: 0.2;\n      }\n\n      .home-bg-right-cls-5 {\n        opacity: 0.25;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_4",
    "data-name": "Rectangle 2 copy 4",
    className: "home-bg-right-cls-1",
    d: "M1774.06,1109.15a28.848,28.848,0,0,0-28.85,28.85v7.93a28.85,28.85,0,1,0,57.7,0v-33.18h7.21v33.18a36.06,36.06,0,1,1-72.12,0V1138a36.069,36.069,0,0,1,36.06-36.07h123.33v7.22H1774.06ZM1802.91,959h7.21v140.77h-7.21V959Z",
    transform: "translate(-1738 -959)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_9",
    "data-name": "Rectangle 2 copy 9",
    className: "home-bg-right-cls-2",
    d: "M1853,1499a27,27,0,0,0,27,27h157v8H1880a35,35,0,0,1,0-70h56v8h-56A27,27,0,0,0,1853,1499Z",
    transform: "translate(-1738 -959)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_11",
    "data-name": "Ellipse 1 copy 11",
    className: "home-bg-right-cls-3",
    cx: 198,
    cy: 509,
    r: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7",
    "data-name": "Rectangle 2 copy 7",
    className: "home-bg-right-cls-4",
    d: "M2037,1315H1823a30,30,0,0,0,0,60h66v5h-66a35,35,0,0,1,0-70h214v5Z",
    transform: "translate(-1738 -959)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_8",
    "data-name": "Ellipse 1 copy 8",
    className: "home-bg-right-cls-3",
    cx: 150.5,
    cy: 418.5,
    r: 2.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy_4",
    "data-name": "Rectangle 3 copy 4",
    className: "home-bg-right-cls-5",
    x: 211,
    y: 192,
    width: 88,
    height: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_13",
    "data-name": "Ellipse 1 copy 13",
    className: "home-bg-right-cls-3",
    cx: 210.5,
    cy: 194.5,
    r: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy",
    "data-name": "Rectangle 3 copy",
    className: "home-bg-right-cls-6",
    x: 131,
    y: 291,
    width: 168,
    height: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_7",
    "data-name": "Ellipse 1 copy 7",
    className: "home-bg-right-cls-3",
    cx: 131,
    cy: 296,
    r: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_4",
    "data-name": "Ellipse 1 copy 4",
    className: "home-bg-right-cls-3",
    cx: 159.39,
    cy: 146.55,
    r: 3.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGraph);
export default __webpack_public_path__ + "static/media/right-graph.64f908588d10e5ad81a2f896106354ad.svg";
export { ForwardRef as ReactComponent };